export default __webpack_public_path__ + "static/media/household-keymap-12-5@2x.5f7c29d3.png";